import { Component, EventEmitter, Input, Output, ElementRef, ViewChild, ChangeDetectorRef, OnChanges, SimpleChanges, AfterViewInit  } from '@angular/core';
import { Colmodel } from './templateRef';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnChanges, AfterViewInit{
  tableElement!: HTMLElement
  @ViewChild('tableContainer') tableContainer!: ElementRef;

  @Input() tableData: any[] = [];
  @Input() columns: Colmodel[] = [];
  @Input() showFilter: boolean = false;
  @Input() isSearch: boolean = true;
  @Input() isSortIcon: boolean = true;
  @Input() paginator: boolean = true;
  @Input() isToggleVisibility: boolean = true;
  @Input() totalRecords: number = 0;
  @Input() rowsPerPage: number = 20;
  @Input() isPdfDownload: boolean = false;
  @Input() reportName: string = '';
  @Input() reportHeading: string = '';
  @Output() onPdfDownload = new EventEmitter();
  @Output() filterChange = new EventEmitter<{ column: string, value: string }>();
  @Output() pageChange = new EventEmitter<{ page: number, rows: number }>();
  @Output() onColumnToggle = new EventEmitter();

  sortField: string | null = null;
  sortOrder: number = 1;

  constructor(private cdr: ChangeDetectorRef) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['isPdfDownload'] && changes['isPdfDownload'].currentValue) {
      this.downloadPDF();
    }
  }

  ngAfterViewInit() {
    this.tableElement = this.tableContainer.nativeElement.querySelector('table')!;
    this.onColumnToggle.emit(this.columns);
  }

  toggleColumnVisibility(columnKey: string): void {
    const column = this.columns.find(col => col.key === columnKey);
    if (column) column.visible = !column.visible;
    this.onColumnToggle.emit(this.columns);
  }

  onFilterChange(column: string, value: string) {
    this.filterChange.emit({ column, value });
  }

  onSort(event: any) {
    this.sortField = event.field;
    this.sortOrder = event.order;
    this.sortData();
  }

  onPageChange(event: any) {
    this.pageChange.emit({ page: event.first / event.rows + 1, rows: event.rows });
  }

  sortData() {
    if (!this.sortField) return;

    this.tableData.sort((a, b) => {
      let valueA = a[this.sortField];
      let valueB = b[this.sortField];

      if (typeof valueA === 'string') valueA = valueA.toLowerCase();
      if (typeof valueB === 'string') valueB = valueB.toLowerCase();

      if (valueA < valueB) return -1 * this.sortOrder;
      if (valueA > valueB) return 1 * this.sortOrder;
      return 0;
    });
  }

  resetColumnVisibility(): void {
    this.columns.forEach(col => col.visible = true);
  }

  isAnyColumnHidden(): boolean {
    return this.columns.some(col => !col.visible);
  }  

  downloadPDF() {
    const tableContainer = this.tableContainer.nativeElement;
  
    if (!this.tableElement) {
      console.error('Table element not found');
      return;
    }
  
    // Preserve previous styles
    const previousOverflow = tableContainer.style.overflow;
    const previousWidth = this.tableElement.style.width;
    const previousRowsPerPage = this.rowsPerPage;
  
    // Expand table for capturing
    this.rowsPerPage = this.totalRecords;
    tableContainer.style.overflow = 'visible';
    this.tableElement.style.width = '100%';
  

    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden';
    this.tableElement.style.backgroundColor = '#FFFFFF';
  
    this.cdr.detectChanges();
  
    html2canvas(this.tableElement, {
      scale: 2,
      logging: false,
      useCORS: true
    }).then(originalCanvas => {
      const MAX_WIDTH = 1500;
      const scale = Math.min(MAX_WIDTH / originalCanvas.width, 1);
  
      const scaledWidth = originalCanvas.width * scale;
      const scaledHeight = originalCanvas.height * scale;
  
      const scaledCanvas = document.createElement('canvas');
      scaledCanvas.width = scaledWidth;
      scaledCanvas.height = scaledHeight;
  
      const ctx = scaledCanvas.getContext('2d');
      ctx.drawImage(originalCanvas, 0, 0, scaledWidth, scaledHeight);
  
      const imgData = scaledCanvas.toDataURL('image/jpeg', 0.8);
  
      const pdf = new jsPDF('l', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
  
      const imgWidth = pageWidth;
      const imgHeight = (scaledCanvas.height * imgWidth) / scaledCanvas.width;
  
      // Add title
      pdf.setFontSize(16);
      pdf.text(`${this.reportHeading}`, 10, 10);
  
      // Multi-page logic
      let remainingHeight = imgHeight;
      let yOffset = 0;
      let pageIndex = 0;
  
      while (remainingHeight > 0) {
        const sliceHeight = (pageHeight - (pageIndex === 0 ? 20 : 0));
        const sliceCanvas = document.createElement('canvas');
        sliceCanvas.width = scaledCanvas.width;
        sliceCanvas.height = (sliceHeight * scaledCanvas.width) / imgWidth;
  
        const sliceCtx = sliceCanvas.getContext('2d');
  
        sliceCtx.fillStyle = '#FFFFFF';
        sliceCtx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
  
        sliceCtx.drawImage(
          scaledCanvas,
          0,
          yOffset * (scaledCanvas.height / imgHeight),
          scaledCanvas.width,
          sliceCanvas.height,
          0,
          0,
          sliceCanvas.width,
          sliceCanvas.height
        );
  
        const sliceData = sliceCanvas.toDataURL('image/jpeg', 0.8);
  
        if (pageIndex > 0) {
          pdf.addPage();
        }
  
        const yPosition = pageIndex === 0 ? 20 : 0;
        pdf.addImage(sliceData, 'JPEG', 0, yPosition, imgWidth, (sliceCanvas.height * imgWidth) / scaledCanvas.width);
  
        remainingHeight -= sliceHeight;
        yOffset += sliceHeight;
        pageIndex++;
      }

      pdf.save(`${this.reportHeading}.pdf`);
      document.body.style.overflow = '';
      this.tableElement.style.backgroundColor = '';
      this.rowsPerPage = previousRowsPerPage;
      tableContainer.style.overflow = previousOverflow;
      this.tableElement.style.width = previousWidth;
  
      this.cdr.detectChanges();
      this.onPdfDownload.emit(true);
    });
  }
  
  
  
  
}
